export const AUTUMN = 0b1000;
export const WINTER = 0b0100;
export const SPRING = 0b0010;
export const SUMMER = 0b0001;

export const ANY_SEASON = SUMMER | WINTER | SPRING | AUTUMN;

export const seasonAnd = (list: number[]) =>
  list.reduce((agg, next) => agg & next, ANY_SEASON);

export const seasonOr = (list: number[]) =>
  list.reduce((agg, next) => agg | next, 0);

export const MAX_NUM_OF_PLANTS_PER_COMBINATION = 10;
